import React from 'react';
import { TaskDetailsResponse } from 'web-library/models/Request';
import AdminDetails from './AdminDetails';
import CandidateDetails from './CandidateDetails';
import CoordinatorDetails from './CoordinatorDetails';

export interface AccountManagementDetailsProps {
  taskDetails: TaskDetailsResponse;
}

const AccountManagementDetails = ({ taskDetails }: AccountManagementDetailsProps) => {
  if (
    !taskDetails?.content.school &&
    !taskDetails?.content.candidateInfoDetail?.school &&
    !taskDetails?.content.coordinatorName &&
    !taskDetails?.content.coordinatorDetail?.coordinatorName
  ) {
    if (taskDetails?.content?.adminModel) {
      return <AdminDetails adminProfileDetails={taskDetails?.content.adminModel} />;
    }

    return <AdminDetails adminProfileDetails={taskDetails?.content} />;
  }

  return (
    <>
      {taskDetails?.content.school && (
        <CandidateDetails candidateProfileDetails={taskDetails?.content} />
      )}

      {taskDetails?.content.candidateInfoDetail?.school && (
        <CandidateDetails candidateProfileDetails={taskDetails?.content.candidateInfoDetail} />
      )}

      {taskDetails?.content.coordinatorName && (
        <CoordinatorDetails coordinatorProfileDetails={taskDetails?.content} />
      )}

      {taskDetails?.content.coordinatorDetail?.coordinatorName && (
        <CoordinatorDetails coordinatorProfileDetails={taskDetails?.content.coordinatorDetail} />
      )}
    </>
  );
};

export default AccountManagementDetails;
